<template>
  <v-dialog v-model="dialog" min-width="600" :max-width="options.width" @keydown.esc="cancel">
    <v-card>
      <v-toolbar  dark flat color="primary lighten-3" dense>
        <v-toolbar-title>{{ title }}</v-toolbar-title>
      </v-toolbar>
      <v-card-text class="pt-5" v-show="!!message">{{ message }}</v-card-text>
      <v-card-actions class="pt-0">
        <slot name="btn-area">
        <v-spacer></v-spacer>
        <rx-btn @click.native="cancel" color="grey" outlined tile class="ma-1" >
            <v-icon left>$vuetify.icons.btn_cancel</v-icon>
            {{ $t("common.btn.no")}}
        </rx-btn>
      <rx-btn @click.native="agree" color="error" outlined tile class="ml-1">
        <v-icon left>$vuetify.icons.btn_save</v-icon>
        {{ $t("common.btn.yes")}}
      </rx-btn>
        </slot>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
  export default {
    data: () => ({
      dialog: false,
      resolve: null,
      reject: null,
      message: null,
      title: null,
      options: {
        color: 'primary',
        width: 290
      }
    }),
    methods: {
      open(title, message, options) {
        this.dialog = true
        this.title = title
        this.message = message
        this.options = Object.assign(this.options, options)
        return new Promise((resolve, reject) => {
          this.resolve = resolve
          this.reject = reject
        })
      },
      agree() {
        this.resolve(true)
        this.dialog = false
      },
      cancel() {
        this.resolve(false)
        this.dialog = false
      }
    }
  }
</script>